export function dateToIso(v: any) {
  if (v == null || v === undefined) {
    return v;
  }
  let date: Date = null;
  if (typeof v == 'string' || typeof v == 'number') {
    try {
      date = new Date(v);
    } catch (error) {
      return v;
    }
  } else if (v.toDate != null) {
    date = v.toDate();
  } else {
    date = v;
  }
  if (date.toISOString) {
    return date.toISOString();
  }
  return date;
}

export function isoDateWithoutTimeZone(date: Date) {
  if (date == null) return date;

  var timezoneOffset = date.getMinutes() + date.getTimezoneOffset();
  var timestamp = date.getTime() - timezoneOffset * 60000;
  var correctDate = new Date(timestamp);
  correctDate.setUTCHours(0, 0, 0, 0);

  return correctDate.toISOString();
}
export function lastDayOf(date: Date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0,23,59,59);
}
export const MONTHS_OF_THE_YEAR = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
];
